/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionInfoWithBoards = {
  properties: {
    id: {
      type: 'string',
      isRequired: true,
    },
    displayName: {
      type: 'string',
      isRequired: true,
    },
    status: {
      type: 'OnboardingProfessionStatus',
      isRequired: true,
    },
    boards: {
      type: 'array',
      contains: {
        type: 'BoardInfo',
      },
      isRequired: true,
    },
  },
} as const;
